import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { ScopeT } from 'business/definitions';
import Flex from 'ui/Flex/Flex';
import ScopeEditor from './components/ScopesEditor/ScopeEditor';
import { useShouldDisplayUserWriteScopes } from './hooks/useShouldDisplayWriteScopes';
import { useUserCreationFormContext } from '../../CreateUserContext/CreateUserFormContext';
import WriteScopeEditor from './components/ScopesEditor/WriteScopeEditor';

interface ScopeFormStepProps {
    scope: ScopeT;
}

export const ScopeFormStep = ({ scope }: ScopeFormStepProps) => {
    const { t } = useTranslation();
    const { roles } = useUserCreationFormContext();
    const shouldDisplayUserWriteScopes = useShouldDisplayUserWriteScopes(roles);
    return (
        <Flex gap={3} flexDirection="column">
            <Typography variant="body1Bold">
                {t(
                    'adminSpace.createUser.modalStepper.scopeSection.description',
                    { scopeLabel: scope.label },
                )}
            </Typography>
            <ScopeEditor scope={scope} />
            {shouldDisplayUserWriteScopes(scope) && (
                <WriteScopeEditor scope={scope} />
            )}
        </Flex>
    );
};
